// ProductForm.js
import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { BiTrash } from 'react-icons/bi';
import AutocompleteSelect from 'components/AutocompleteSelect/AutocompleteSelect';

function ProductForm({
  product,
  index,
  handleProductChange,
  removeProduct,
  productOptions,
  totalProducts,
  mobileTwoLines = false,
  onCreateNewProduct,
  accountOptions = [],
  showAccount = false,
}) {

  return (
    <div
      className={`d-flex row mb-2 product-form-row ${
        mobileTwoLines ? "product-form-row--two-lines" : ""
      }`}
    >
      <Col className={`col-6 ${mobileTwoLines ? "product-form-col--product" : ""}`}>
        <Form.Group controlId={`product-${index}`}>
          <AutocompleteSelect
            label="Produit"
            options={productOptions || []}
            value={product.produit}
            onChange={(value) => {
              // Simuler un event pour le handleProductChange existant
              const fakeEvent = {
                target: { name: "produit", value: value }
              };
              handleProductChange(index, fakeEvent);
            }}
            onCreateNew={onCreateNewProduct}
            placeholder="Saisissez ou sélectionnez un produit"
            createText="Créer le produit"
          />
        </Form.Group>
      </Col>
      <Col className={`col-6 ${mobileTwoLines ? "product-form-col--details" : ""}`}>
        <div className={`d-flex align-items-end gap-3 ${mobileTwoLines ? "product-form-details-row" : ""}`}>
          <Form.Group
            controlId={`quantity-${index}`}
            className={mobileTwoLines ? "product-form-field product-form-field--qty" : "w-50"}
          >
            <Form.Label className="mb-2">Quantité</Form.Label>
            <Form.Control
              type="number"
              name="quantite"
              value={product.quantite || 1}
              onChange={(e) => handleProductChange(index, e)}
              className="rounded rounded-pill"
            />
          </Form.Group>
          <Form.Group
            controlId={`price-${index}`}
            className={mobileTwoLines ? "product-form-field product-form-field--price" : "w-50"}
          >
            <Form.Label className="mb-2">Prix</Form.Label>
            <Form.Control
              type="number"
              name="prix"
              value={product.prix || ''}
              onChange={(e) => handleProductChange(index, e)}
              className="rounded rounded-pill"
            />
          </Form.Group>
          {totalProducts > 1 && (
            <BiTrash
              className={`fs-2 text-danger ${mobileTwoLines ? "product-form-trash" : ""}`}
              style={{ cursor: 'pointer' }}
              onClick={() => removeProduct(index)}
            />
          )}
        </div>
      </Col>
      {showAccount && (
        <Col className="col-12 mt-1">
          <Form.Group controlId={`account-${index}`}>
            <AutocompleteSelect
              label="Compte comptable (optionnel)"
              options={accountOptions}
              value={product.code_comptable ?? null}
              onChange={(value) => {
                // Sélection => code numérique ; frappe libre => texte
                const fakeEvent = {
                  target: { name: "code_comptable", value: value }
                };
                handleProductChange(index, fakeEvent);
              }}
              createText="Utiliser"
              onCreateNew={async (name) => {
                // Le compte tapé n'existe pas dans le plan : on l'utilise
                // quand même : le backend le créera automatiquement.
                const digits = String(name).replace(/\D/g, "");
                if (!digits) return null;
                return { id: Number(digits), nom: String(name).trim() };
              }}
              placeholder="Ex: 706000 - Services rendus (laisser vide = compte du produit)"
            />
          </Form.Group>
        </Col>
      )}
    </div>
  );
}

export default ProductForm;
